import api from '../api/news-api';

export default {
    addNews(data) {
        return new Promise((resolve, reject) => {
            api.addNews(data).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    updateNews(data) {
        return new Promise((resolve, reject) => {
            api.updateNews(data).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getNews() {
        return new Promise((resolve, reject) => {
            api.getNews().then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    launchNews(id) {
        return new Promise((resolve, reject) => {
            api.launchNews(id).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    withdrawNews(id) {
        return new Promise((resolve, reject) => {
            api.withdrawNews(id).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    readNews(ids) {
        return new Promise((resolve, reject) => {
            api.readNews(ids).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    delNews(id) {
        return new Promise((resolve, reject) => {
            api.delNews(id).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
}